import React from 'react';
import logo from '../../../../assets/images/superset-logo@2x.png';

export const Logo = ({ width, height }: { width: string; height: string }) => {
  return (
    <div style={{ width: width, height: height }}>
      <img src={logo} alt={'logo'} />
    </div>
  );
};
